module.exports = __webpack_public_path__ + "static/media/lang-ico.3a45e2e4.svg";